export default "__VITE_ASSET__b0t60_Ir__"